var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 46,
    viewBox: "0 0 61 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.51 14.755a5.883 5.883 0 003.596 4.519c3.853 1.42 6.871 4.583 8.155 8.586a13.559 13.559 0 01-1.412 11.749c-2.184 3.55-5.908 5.81-10.018 6.262V46H15.246v-.065c-5.073-.451-9.632-3.227-12.457-7.488-2.826-4.26-3.532-9.62-1.991-14.46a16.553 16.553 0 0110.018-10.588 5.7 5.7 0 003.21-2.905C16.274 5.846 20.32 2.295 25.264.81c4.945-1.549 10.274-.839 14.705 1.808 4.431 2.647 7.514 7.037 8.541 12.137zm-8.798 12.007c.578 0 1.156-.194 1.606-.645.385-.452.514-1.033.514-1.614 0-.581-.193-1.162-.643-1.614l-9.118-9.167c-.385-.388-1.028-.646-1.605-.646-.579 0-1.157.194-1.606.646l-9.119 9.167c-.578.58-.77 1.42-.578 2.195.193.774.835 1.42 1.606 1.614.77.193 1.605 0 2.183-.581l5.266-5.294V33.67c0 .839.45 1.614 1.156 2.001a2.445 2.445 0 002.312 0c.706-.452 1.156-1.162 1.156-2.001V20.823l5.265 5.294c.385.387 1.027.645 1.605.645z",
    fill: "#485057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.fc9016094fcc696c2ba3e439bf44adbf.svg";
export { ForwardRef as ReactComponent };